<template>
  <table class="striped admin-projects-table">
    <caption v-html="caption" v-if="caption" />
    <thead>
      <tr>
        <th>Project</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="project in paginatedProjects"
        :key="project.id"
        :class="selectedId === project.id ? 'selected' : 'selectable'"
        @click="handleSelect(project)"
      >
        <td>{{ project.name }}</td>
      </tr>
      <tr v-if="projects.length === 0">
        <td class="no-records">
          There are currently no projects in the system.
        </td>
      </tr>
    </tbody>
    <tfoot v-if="hasPages">
      <tr>
        <td class="page-controls">
          <icon-button
            :disabled="!hasPrevPage"
            name="prev"
            @click="goToPrevPage"
          />

          <icon-button
            :disabled="!hasNextPage"
            name="next"
            @click="goToNextPage"
          />
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import { pagination } from "../../mixins/pagination";

export default {
  mixins: [pagination("projects")],

  props: {
    caption: {
      type: String,
      default: undefined,
    },
    projects: {
      type: Array,
    },
    selectedId: {
      type: Number,
      default: -1,
    },
  },

  methods: {
    handleSelect(project) {
      this.$emit("select", project);
    },
  },
};
</script>